// src/App.js
import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate
} from "react-router-dom";

import { Layout } from "./components/common/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Practice } from "./pages/Practice";
import Pricing from "./pages/Pricing";
import { WhyUs } from "./pages/WhyUs";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import SubjectPapers from "./pages/SubjectPapers";
import { useVisitorCount } from "./components/common/useVisitorCount";

function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    if (!accessToken) {
      navigate("/login");
    }
  }, [accessToken, navigate]);

  return accessToken ? children : null;
}

function App() {
  useVisitorCount();

  return (
    <BrowserRouter>
      <Routes>
        {/* Home & static pages */}
        <Route path="/"      element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/why-us"element={<Layout><WhyUs /></Layout>} />
        <Route path="/pricing"element={<Layout><Pricing /></Layout>} />
        <Route path="/contact"element={<Layout><Contact /></Layout>} />

        {/* Authentication */}
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route
          path="/admin"
          element={
            <Layout>
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            </Layout>
          }
        />

        {/* Resources by type/grade */}
        <Route
          path="/resources/:type/:grade/:subject"
          element={<Layout><SubjectPapers /></Layout>}
        />

        {/* Practice landing (all grades selector) */}
        <Route
          path="/practice"
          element={<Layout><Practice /></Layout>}
        />

        {/* Practice by grade (NEW!) */}
        <Route
          path="/practice/:grade"
          element={<Layout><Practice /></Layout>}
        />

        {/* Practice detail */}
        <Route
          path="/practice/:grade/:examKey"
          element={<Layout><Practice /></Layout>}
        />

        {/* catch-all 404 */}
        <Route
          path="*"
          element={
            <Layout>
              <div className="text-center py-16 text-pink-600">
                <h1 className="text-2xl font-semibold">Oops! Page Not Found.</h1>
              </div>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
